'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var ReturnsConfigProvider = require('../../providers/ReturnsConfigProvider.js');
var raw = require('./raw.js');
var useLanguage = require('../../hooks/language/useLanguage.js');
var useCurrencyConfig = require('../../hooks/useCurrencyConfig.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Confirmation = props => {
  const {
    isHipaaCompliant
  } = ReturnsConfigProvider.useReturnsConfig();
  const {
    locale,
    includeCurrency
  } = useCurrencyConfig["default"]();
  const langKeySuffix = isHipaaCompliant ? 'Hipaa' : '';
  const {
    providerMoniker = '',
    refundMethod = '',
    location,
    type = ''
  } = props;
  const {
    value: provider
  } = useLanguage["default"]({
    langKey: `returnsMoniker${providerMoniker}DisplayName`,
    asString: true
  });
  const replacementTokens = useLanguage.generateTokensFromObject({
    provider,
    location: location === null || location === void 0 ? void 0 : location.displayName
  });
  const {
    value: Step1Title
  } = useLanguage["default"]({
    langKey: `returnsConfirmation${type}Step1Title`,
    asString: true,
    replacementTokens
  });
  const {
    value: Step1Details
  } = useLanguage["default"]({
    langKey: `returnsConfirmation${type}Step1Details`,
    asString: true,
    replacementTokens
  });
  const {
    value: Step2Title
  } = useLanguage["default"]({
    langKey: `returnsConfirmation${type}Step2Title${langKeySuffix}`,
    asString: true,
    replacementTokens
  });
  const {
    value: Step2Details
  } = useLanguage["default"]({
    langKey: `returnsConfirmation${type}Step2Details`,
    asString: true,
    replacementTokens
  });
  const {
    value: Step3Title
  } = useLanguage["default"]({
    langKey: `returnsConfirmation${type}Step3Title`,
    asString: true,
    replacementTokens
  });
  const {
    value: Step3Details
  } = useLanguage["default"]({
    langKey: `returnsConfirmation${type}Step3Details`,
    asString: true,
    replacementTokens
  });
  const {
    rawValue: providerLinkUrl
  } = useLanguage["default"]({
    langKey: `returnsMoniker${providerMoniker}LinkUrl`,
    asString: true
  });
  const {
    value: providerLinkText
  } = useLanguage["default"]({
    langKey: `returnsMoniker${providerMoniker}LinkText`,
    asString: true,
    replacementTokens
  });
  const refundStepTitle = useLanguage["default"]({
    langKey: `returnsConfirmation${refundMethod}StepTitle`
  }).value;
  const refundStepDetails = useLanguage["default"]({
    langKey: `returnsConfirmation${refundMethod}StepDetails`
  }).value;
  const refundStepAppStoreLink = useLanguage["default"]({
    langKey: `returnsConfirmation${refundMethod}StepAppStoreLink`
  }).value;
  const refundStepAppStoreLinkText = useLanguage["default"]({
    langKey: `returnsConfirmation${refundMethod}StepAppStoreLinkText`
  }).value;
  const refundStepGooglePlayLink = useLanguage["default"]({
    langKey: `returnsConfirmation${refundMethod}StepGooglePlayLink`
  }).value;
  const refundStepGooglePlayLinkText = useLanguage["default"]({
    langKey: `returnsConfirmation${refundMethod}StepGooglePlayLinkText`
  }).value;
  const steps = React.useMemo(() => {
    const link = providerLinkText && providerLinkUrl ? {
      text: providerLinkText,
      url: providerLinkUrl
    } : undefined;
    const step2Link = type === 'printerless_mail' && link ? [link] : [];
    const step3Link = (type === 'mail' || type === 'concierge') && link ? [link] : [];
    let ret = [];
    if (refundMethod === 'reshop') {
      ret = [...ret, {
        title: refundStepTitle,
        details: refundStepDetails,
        links: [{
          text: refundStepAppStoreLinkText,
          url: refundStepAppStoreLink ?? '',
          image: 'app_store'
        }, {
          text: refundStepGooglePlayLinkText,
          url: refundStepGooglePlayLink ?? '',
          image: 'google_play'
        }]
      }];
    }
    ret = [...ret, {
      title: Step1Title,
      details: Step1Details
    }, {
      title: Step2Title,
      details: Step2Details,
      links: step2Link
    }];
    if (Step3Title) {
      ret = [...ret, {
        title: Step3Title,
        details: Step3Details,
        links: step3Link
      }];
    }
    return ret;
  }, [type, refundMethod, refundStepTitle, refundStepDetails, refundStepAppStoreLinkText, refundStepAppStoreLink, refundStepGooglePlayLinkText, refundStepGooglePlayLink, providerLinkText, providerLinkUrl, Step1Title, Step1Details, Step2Title, Step2Details, Step3Title, Step3Details]);
  return /*#__PURE__*/React__default["default"].createElement(raw.ConfirmationRaw, _extends__default["default"]({
    isHipaaCompliant: isHipaaCompliant,
    locale: locale,
    includeCurrency: includeCurrency
  }, props, {
    returnSteps: steps
  }));
};

exports.ConfirmationRaw = raw.ConfirmationRaw;
exports.Confirmation = Confirmation;
